import { render } from "./Degree.vue?vue&type=template&id=ae96a8ca&scoped=true&ts=true"
import script from "./Degree.vue?vue&type=script&lang=ts"
export * from "./Degree.vue?vue&type=script&lang=ts"

import "./Degree.vue?vue&type=style&index=0&id=ae96a8ca&lang=scss&scoped=true"
import "./Degree.vue?vue&type=style&index=1&id=ae96a8ca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae96a8ca"]])

export default __exports__